<template>
    <div class="gw-ranking-top-provider-discount">
        <template v-for="(provider, key) in this.providers">
            <a
                v-if="key === 0"
                :href="gotoLink(provider)"
                :key="'gw_ranking_partner_' + key"
                target="_blank"
            >
                <div class="heading">
                    &#10041; {{ $t('HOT TIME OFFER') }}
                    <template v-if="provider['marketing']['discount btn']">
                        |
                        <span>
                            {{ $t('Only') }}
                            {{ formatUnitValue(countdownTimer.hours) }}
                            {{ $t('hours') }}
                            {{ formatUnitValue(countdownTimer.minutes) }}
                            {{ $t('m') }}
                            {{ formatUnitValue(countdownTimer.seconds) }}
                            {{ $t('s') }}
                            {{ $t('Left!') }}
                        </span>
                    </template>
                </div>
                <div class="partner-row">
                    <div class="logo">
                        <img
                            width="180px"
                            height="90px"
                            v-lazy="getLogo(provider)"
                            :alt="provider['provider_name']"
                        />
                    </div>

                    <div
                        class="discount-btn"
                        v-if="provider['marketing']['discount btn']"
                    >
                        <p>{{ provider['marketing']['discount btn'] }}</p>
                    </div>
                    <div
                        class="desc"
                        v-else
                        v-html="provider['marketing']['members']"
                    />

                    <div class="cta-button">
                        <button>{{ $t('Try It Out Risk-Free') }}</button>
                    </div>
                </div>
            </a>
        </template>
    </div>
</template>

<script>
import { ghostWriterRankingMixin, countdownTimerMixin } from '@/ghost-mixins';

export default {
    name: 'HighlightedTopProvider',
    mixins: [ghostWriterRankingMixin, countdownTimerMixin],
    props: {
        providers: {
            type: Array,
            default: () => [],
        },
    },
    methods: {
        getEndTime() {
            let endTime = new Date();
            endTime.setDate(endTime.getDate() + 1);
            endTime.setHours(0, 0, 0);
            return endTime;
        },
    },
    mounted() {
        const endTime = this.getEndTime();
        setInterval(() => {
            this.setTimer(endTime);
        }, 1000);
    },
};
</script>

<style lang="scss" scoped>
@import '@/sass/mixins';

.gw-ranking-top-provider-discount {
    display: flex;
    flex-direction: column;
    .heading {
        padding: 10px 20px;
        background: var(--gw-btn-bg-color);
        color: var(--gw-btn-text-color);
        border-radius: 12px 12px 0 0;
        font-weight: bolder;
        span {
            font-weight: 400;
        }
    }
    .partner-row {
        padding: 10px;
        display: flex;
        flex-direction: column;
        gap: 15px;
        align-items: center;
        border: solid #ebe6e6;
        border-top: none;
        background: white;
        border-radius: 0 0 12px 12px;
        box-shadow: 0 3px 3px 0 rgba(0, 105, 191, 0.1);
        @include mq('desktop') {
            gap: 0;
            display: grid;
            grid-template-areas: 'logo discount-btn cta-btn';
            grid-template-columns: 200px auto auto;
        }

        .logo {
            display: flex;
            justify-content: center;
            grid-area: logo;
            padding: 5px;
            font-weight: bolder;

            img {
                object-fit: contain;
            }

            @include mq('desktop') {
                display: inherit;
                justify-content: normal;
            }
        }

        .discount-btn {
            grid-area: discount-btn;
            p {
                background: var(--gw-discount-btn-bg-color);
                color: var(--gw-discount-btn-text-color);
                padding: 10px;
                font-size: 0.8em;
                text-align: center;
                font-weight: bolder;
                border-radius: 5px;
                line-height: 18px;
            }
        }

        .desc {
            text-align: center;
            @include mq('tablet') {
                text-align: initial;
            }
        }
        .cta-button {
            text-align: right;
            display: flex;
            align-items: center;
            grid-area: cta-btn;

            button {
                background: transparent;
                color: var(--gw-btn-bg-color);
                text-align: center;
                padding: 10px;
                font-size: 14px;
                font-weight: bolder;
                min-height: 40px;
                width: 100%;
                border-radius: 5px;
                cursor: pointer;
                z-index: 2;
                text-decoration: underline;
                @include mq('desktop') {
                    text-align: right;
                }
            }
        }

        .icons {
            grid-area: icons;
        }
    }
}
</style>
